import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteImagesProvider } from "@/context/SiteImagesContext";
import { SiteContentProvider } from "@/context/SiteContentContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { InstallPWA } from "@/components/InstallPWA";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import UpscalePage from "@/pages/UpscalePage";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <SiteImagesProvider>
          <SiteContentProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/upscale" element={<UpscalePage />} />
              </Routes>
            </BrowserRouter>
          </SiteContentProvider>
        </SiteImagesProvider>
      </LanguageProvider>
      <InstallPWA />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
